import type { EditorialContentDetail } from "@/api/researchCms.service";

/** The human twin of the transform's claim-and-stamp: a researcher saving from a table-scoped
 * view has named the table, so the row it opened acquires it. */
export function rankingTableStamp(
  rankingTableId: string | undefined,
  target: Pick<EditorialContentDetail, "rankingTableId">,
): { rankingTableId: string } | Record<string, never> {
  // Absent for the untabled scope and for an unscoped view; a row already attributed keeps its
  // own table, so neither ever writes one.
  if (!rankingTableId || target.rankingTableId != null) return {};
  return { rankingTableId };
}
